module.exports = __webpack_public_path__ + "img/filter-reset.808b8c8.svg";